export interface FilterItem {
  subType: string;
  key: string;
  label?: string;
}

export interface Filter {
  name?: string;
  title: string;
  items: Array<FilterItem>;
}

export interface CustomerFilter {
  risks?: string;
  recordType?: string;
  status?: string;
  active?: string;
  integrationStatus?: string;
}

export enum SearchCustomerStatusOptions {
  DRAFT = 'DRAFT',
  PENDING = 'PENDING',
  REQUEST_CHANGES = 'REQUEST CHANGES',
  ACCEPTED = 'ACCEPTED',
  REJECTED = 'REJECTED',
  CLEARED = 'CLEARED',
  REQUIRE_UPDATE = 'REQUIRE UPDATE',
  UPDATED = 'UPDATED'
}

export enum SearchCustomerRiskRatingOptions {
  LOW = 'LOW',
  MEDIUM = 'MEDIUM',
  HIGH = 'HIGH',
  UNKNOWN = 'UNKNOWN'
}

export enum SearchCustomerRecordTypeOptions {
  INDIVIDUAL = 'INDIVIDUAL',
  CORPORATE = 'CORPORATE'
}

export enum SearchCustomerIsActiveOptions {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE'
}
